module.exports = __webpack_public_path__ + "img/Dantam Hair 19.4f8a99b0.jpg";